(function () {
  'use strict';

  var SELECTORS = {
    header: '.entete',
    menuToggle: '[data-menu-toggle]',
    mobileMenu: '#mobile-menu',
    menuClose: '[data-menu-close]',
    menuBackdrop: '[data-menu-backdrop]',
    reveal: '.lv-reveal, [data-reveal]',
    counter: '[data-count]',
    faqItem: '[data-faq-item]',
    faqButton: '[data-faq]',
    faqPanel: '[data-faq-panel]',
    faqIcon: '[data-faq-icon]',
    galleryMain: '[data-gallery-main]',
    galleryThumb: '[data-gallery-thumb]',
    qtyGroup: '[data-quantity-group]',
    stickyAtc: '[data-sticky-atc]',
    productAnchor: '[data-product-anchor]',
    localizationSelect: '[data-localization-select]',
    variantSelect: '[data-variant-select]',
    productForm: '[data-product-form]'
  };

  function ready(callback) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', callback);
      return;
    }

    callback();
  }

  function initHeader() {
    var header = document.querySelector(SELECTORS.header);
    var toggle = document.querySelector(SELECTORS.menuToggle);
    var menu = document.querySelector(SELECTORS.mobileMenu);
    var close = document.querySelector(SELECTORS.menuClose);
    var backdrop = document.querySelector(SELECTORS.menuBackdrop);

    if (header) {
      var headerSection = header.closest('.section-entete');
      var announcement = headerSection ? headerSection.querySelector('.bandeau-promo') : null;

      var updateAnnouncementHeight = function () {
        if (!headerSection) return;
        var announcementHeight = announcement ? announcement.offsetHeight : 0;
        headerSection.style.setProperty('--lv-announcement-height', announcementHeight + 'px');
      };

      var updateHeader = function () {
        var scrollPosition = Math.max(window.scrollY, 0);
        var isScrolled = header.classList.contains('is-scrolled');

        if (!isScrolled && scrollPosition > 72) {
          isScrolled = true;
        } else if (isScrolled && scrollPosition < 8) {
          isScrolled = false;
        }

        header.classList.toggle('is-scrolled', isScrolled);
        if (headerSection) headerSection.classList.toggle('is-scrolled', isScrolled);
      };

      updateAnnouncementHeight();
      updateHeader();
      window.addEventListener('scroll', updateHeader, { passive: true });
      window.addEventListener('resize', updateAnnouncementHeight, { passive: true });
    }

    if (!toggle || !menu) return;

    var openMenu = function () {
      menu.classList.add('is-open');
      menu.setAttribute('aria-hidden', 'false');
      toggle.setAttribute('aria-expanded', 'true');
    };

    var closeMenu = function () {
      menu.classList.remove('is-open');
      menu.setAttribute('aria-hidden', 'true');
      toggle.setAttribute('aria-expanded', 'false');
    };

    toggle.addEventListener('click', function () {
      if (menu.classList.contains('is-open')) closeMenu();
      else openMenu();
    });

    if (close) close.addEventListener('click', closeMenu);
    if (backdrop) backdrop.addEventListener('click', closeMenu);

    menu.querySelectorAll('a').forEach(function (link) {
      link.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && menu.classList.contains('is-open')) {
        closeMenu();
      }
    });
  }

  function initLocalizationForms() {
    document.querySelectorAll(SELECTORS.localizationSelect).forEach(function (select) {
      select.addEventListener('change', function () {
        var form = select.closest('form');
        if (form) form.submit();
      });
    });
  }

  function initReveal() {
    var items = document.querySelectorAll(SELECTORS.reveal);
    if (!items.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (prefersReducedMotion || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, {
      threshold: 0.12,
      rootMargin: '0px 0px -6% 0px'
    });

    items.forEach(function (item) {
      observer.observe(item);
    });
  }

  function initCounters() {
    var counters = document.querySelectorAll(SELECTORS.counter);
    if (!counters.length) return;

    var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    var run = function (element) {
      var target = parseInt(element.getAttribute('data-count'), 10) || 0;

      if (prefersReducedMotion) {
        element.textContent = target;
        return;
      }

      var start = performance.now();
      var duration = 1400;

      var step = function (time) {
        var progress = Math.min(1, (time - start) / duration);
        var eased = 1 - Math.pow(1 - progress, 3);
        element.textContent = Math.round(target * eased);
        if (progress < 1) requestAnimationFrame(step);
      };

      requestAnimationFrame(step);
    };

    if (!('IntersectionObserver' in window)) {
      counters.forEach(run);
      return;
    }

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        run(entry.target);
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.6 });

    counters.forEach(function (counter) {
      observer.observe(counter);
    });
  }

  function initChart() {
    document.querySelectorAll('[data-chart-line]').forEach(function (line) {
      var area = line.closest('svg')?.querySelector('[data-chart-area]');
      var dots = line.closest('svg')?.querySelectorAll('[data-dot]') || [];
      var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      if (typeof line.getTotalLength !== 'function') return;

      var length = line.getTotalLength();
      line.style.strokeDasharray = length;
      line.style.strokeDashoffset = prefersReducedMotion ? 0 : length;

      var draw = function () {
        if (prefersReducedMotion) {
          if (area) area.style.opacity = '1';
          dots.forEach(function (dot) { dot.style.opacity = '1'; });
          return;
        }

        line.style.transition = 'stroke-dashoffset 1.6s cubic-bezier(.16,.84,.44,1)';
        line.style.strokeDashoffset = 0;

        if (area) {
          area.style.transition = 'opacity 1s ease .8s';
          area.style.opacity = '1';
        }

        dots.forEach(function (dot, index) {
          dot.style.transition = 'opacity .4s ease ' + (0.5 + index * 0.22) + 's';
          dot.style.opacity = '1';
        });
      };

      if (!('IntersectionObserver' in window)) {
        draw();
        return;
      }

      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          draw();
          observer.disconnect();
        });
      }, { threshold: 0.4 });

      observer.observe(line);
    });
  }

  function initFaq() {
    document.querySelectorAll(SELECTORS.faqItem).forEach(function (item) {
      var button = item.querySelector(SELECTORS.faqButton);
      var panel = item.querySelector(SELECTORS.faqPanel);
      var icon = item.querySelector(SELECTORS.faqIcon);

      if (!button || !panel) return;

      button.addEventListener('click', function () {
        var list = item.parentElement;
        var isOpen = item.classList.contains('is-open');

        if (list) {
          list.querySelectorAll(SELECTORS.faqItem).forEach(function (other) {
            var otherButton = other.querySelector(SELECTORS.faqButton);
            var otherPanel = other.querySelector(SELECTORS.faqPanel);
            var otherIcon = other.querySelector(SELECTORS.faqIcon);
            other.classList.remove('is-open');
            if (otherButton) otherButton.setAttribute('aria-expanded', 'false');
            if (otherPanel) otherPanel.style.maxHeight = '0px';
            if (otherIcon) otherIcon.textContent = '+';
          });
        }

        if (!isOpen) {
          item.classList.add('is-open');
          button.setAttribute('aria-expanded', 'true');
          panel.style.maxHeight = panel.scrollHeight + 'px';
          if (icon) icon.textContent = '-';
        }
      });
    });
  }

  function initGallery() {
    var main = document.querySelector(SELECTORS.galleryMain);
    var thumbs = document.querySelectorAll(SELECTORS.galleryThumb);

    if (!main || !thumbs.length) return;

    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        var src = thumb.getAttribute('data-image-url');
        var srcset = thumb.getAttribute('data-image-srcset');
        var position = thumb.getAttribute('data-image-position') || 'center';
        var alt = thumb.getAttribute('data-image-alt') || main.getAttribute('alt') || '';

        if (!src) return;

        main.style.opacity = '0';
        window.setTimeout(function () {
          main.setAttribute('src', src);
          if (srcset) main.setAttribute('srcset', srcset);
          else main.removeAttribute('srcset');
          main.setAttribute('alt', alt);
          main.style.objectPosition = position;
          main.style.opacity = '1';
        }, 180);

        thumbs.forEach(function (other) {
          other.classList.remove('is-active');
          other.setAttribute('aria-current', 'false');
        });

        thumb.classList.add('is-active');
        thumb.setAttribute('aria-current', 'true');
      });
    });
  }

  function syncFormQuantities(value) {
    document.querySelectorAll('[data-sticky-quantity]').forEach(function (input) {
      input.value = value;
    });
  }

  function initQuantity() {
    document.querySelectorAll(SELECTORS.qtyGroup).forEach(function (group) {
      var input = group.querySelector('input[type="number"]');
      var minus = group.querySelector('[data-quantity-minus]');
      var plus = group.querySelector('[data-quantity-plus]');

      if (!input) return;

      var clamp = function (value) {
        var min = parseInt(input.getAttribute('min'), 10) || 1;
        var max = parseInt(input.getAttribute('max'), 10) || 99;
        return Math.min(max, Math.max(min, value));
      };

      var setValue = function (value) {
        input.value = clamp(value);
        syncFormQuantities(input.value);
      };

      if (minus) {
        minus.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 1) - 1);
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          setValue((parseInt(input.value, 10) || 1) + 1);
        });
      }

      input.addEventListener('change', function () {
        setValue(parseInt(input.value, 10) || 1);
      });
    });
  }

  function initVariantSelects() {
    document.querySelectorAll(SELECTORS.variantSelect).forEach(function (select) {
      select.addEventListener('change', function () {
        var selected = select.options[select.selectedIndex];
        var price = selected?.getAttribute('data-price');
        var compare = selected?.getAttribute('data-compare-price');
        var available = selected?.getAttribute('data-available') === 'true';
        var productRoot = select.closest('[data-product-root]') || document;

        productRoot.querySelectorAll('[data-variant-id]').forEach(function (input) {
          input.value = select.value;
        });

        productRoot.querySelectorAll('[data-product-price]').forEach(function (node) {
          if (price) node.textContent = price;
        });

        productRoot.querySelectorAll('[data-product-compare-price]').forEach(function (node) {
          node.textContent = compare || '';
          node.hidden = !compare;
        });

        productRoot.querySelectorAll('[data-product-submit]').forEach(function (button) {
          button.disabled = !available;
          button.setAttribute('aria-disabled', available ? 'false' : 'true');
          if (button.dataset.availableText && button.dataset.soldOutText) {
            button.querySelector('[data-submit-text]').textContent = available ? button.dataset.availableText : button.dataset.soldOutText;
          }
        });
      });
    });
  }

  function initStickyAtc() {
    var bar = document.querySelector(SELECTORS.stickyAtc);
    if (!bar) return;

    var anchor = document.querySelector(SELECTORS.productAnchor) || document.querySelector('.pdp__grid') || document.querySelector('.lv-hero');

    var update = function () {
      var trigger = anchor ? anchor.getBoundingClientRect().bottom + window.scrollY - 120 : 700;
      bar.classList.toggle('is-visible', window.scrollY > trigger);
    };

    update();
    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
  }

  ready(function () {
    initHeader();
    initLocalizationForms();
    initReveal();
    initCounters();
    initChart();
    initFaq();
    initGallery();
    initQuantity();
    initVariantSelects();
    initStickyAtc();
  });
})();
